import ClearingAPI from '@shared/api';

export const {
    positions: { getAssignedPosition },
    rebalancingJob: { userRebalancing },
} = ClearingAPI.settings;
